import React from 'react';

const KycLandingPage = ({ onProceed, docUrl }) => {
    return (
        <div className="bg-gray-50 py-8">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center space-y-6">
                    <h1 className="text-3xl font-bold text-gray-900">
                        What faceEsign Is:
                    </h1>
                    <h2 className="text-2xl font-semibold text-navy-900">
                        A Plug-in Biometric KYC Tool
                    </h2>
                    
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        It's a KYC and consent module/tool that can plug into any digital transaction - especially in fintech, banking, onboarding or compliance workflows.
                    </p>

                    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 space-y-4">
                        <div className="flex items-center gap-4">
                            <div className="h-10 w-10 bg-green-100 rounded-full flex items-center justify-center">
                                <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <p className="text-gray-700">Confirm liveness</p>
                        </div>
                        <div className="flex items-center gap-4">
                            <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center">
                                <svg className="h-6 w-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                </svg>
                            </div>
                            <p className="text-gray-700">Record biometric evidence of consent</p>
                        </div>
                    </div>

                    <button
                        onClick={() => onProceed(docUrl)}
                        className="mt-6 w-full sm:w-auto px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 
                        hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        Proceed to Verification
                    </button>
                </div>
            </div>
        </div>
    );
};

export default KycLandingPage;